<script>
    export let subtotal = 0;
</script>                


<div class="text-white flex-1 self-center">
    <div class="w-full text-center">
        <span class="text-2xl">{subtotal}</span>
        <br>
        <span class="italic">estimated total</span>
    </div>
</div>